<template>
  <div :class="['lr-modal', {'hide': !show}]">
    <div class="lr-box">
      <div class="header">Generate Codes</div>
      <label>How many codes to generate</label>
      <input type="number" v-model="count" @keypress="isNumber" />
      <br/>
      <a class="button cta small success block" @click="generate">
        Generate
      </a>
      <a class="cta small block" @click="show = false">
        Close
      </a>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
export default {
  name: 'alert',
  data () {
    return {
      show: false,
      brandId: 4,
      count: 5
    }
  },
  methods: {
    showModal () {
      this.show = true
    },
    isNumber (evt) {
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
        return
      }
      return true;
    },
    generate () {
      let self = this

      if (parseFloat(self.count) < 1 || !self.count) {
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'Invalid generate amount'
        })
        return
      }

      self.show = false
      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      self.$sdk.post('/promo/airtag/generate', {
        token: self.$store.state.session.sessionToken,
        brandId: self.brandId,
        num: parseInt(self.count)
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        self.$emit('refreshList')
      })
    }
  },
  mounted () {
    if (CONFIG.Env !== 'production') this.brandId = 12
  },
}
</script>

<style lang="scss" scoped>
.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.lr-box {
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 2px rgba(0,0,0, .3);
  text-align: center;
  min-width: 300px;
  max-width: 500px;
}

.header{
  color: #45505b;
  font-size: 18px;
  font-weight: 600;
}

.button{
  margin-bottom: 10px;
}
.cta{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Airtag/generate.vue